// Tiny line-based diff for showing changes between two disclaimer versions.
// Not full LCS — just paragraph-level "added / removed / kept" using a Set
// comparison, which is more than enough for legal wording where paragraphs
// stay largely intact.
export function paragraphDiff(oldText, newText) {
	const oldPara = (oldText || "").split(/\n{2,}/).map((s) => s.trim()).filter(Boolean);
	const newPara = (newText || "").split(/\n{2,}/).map((s) => s.trim()).filter(Boolean);
	const oldSet = new Set(oldPara);
	const newSet = new Set(newPara);

	const rows = [];
	// Removed paragraphs first
	for (const p of oldPara) {
		if (!newSet.has(p)) rows.push({ status: "removed", text: p });
	}
	// Then added / kept
	for (const p of newPara) {
		rows.push({ status: oldSet.has(p) ? "kept" : "added", text: p });
	}
	return rows;
}
